export const FETCH_BANNERS = 'FETCH_BANNERS'
export const FETCH_BANNER = 'FETCH_BANNER'
export const EDIT_BANNER = 'EDIT_BANNER'
export const CREATE_BANNER = 'CREATE_BANNER'
export const DELETE_BANNER = 'DELETE_BANNER'
export const FETCH_ACTIVE_BANNER = 'FETCH_ACTIVE_BANNER'
export const SET_MODAL = 'SET_MODAL'
